<template>
  <div>
    <p class="payment-title">{{ $t("tariffPayment.paymentVariants") }}</p>
    <!-- @click="onOpenPaymentOptions" -->
    <div
      :class="[`payment-options-block ${isOpenPaymentOptions ? 'open' : ''}`]"
    >
      <!-- <chevron-right-icon
        class="dropdown-chevron-icon"
        :style="isOpenPaymentOptions ? { transform: 'rotate(90deg)' } : {}"
      /> -->
      <div :class="`${isOpenPaymentOptions ? 'use-payment-container' : ''}`">
        <div v-if="usedPaymentMethod === 'stars'" class="used-payment-method">
          <div class="payment-type-image-block">
            <star-icon class="payment-type-icon" />
          </div>
          <div>
            <p class="menu-item-name">
              {{ $t("tariffPayment.starsPaymnt") }}
            </p>
            <!-- <p class="menu-item-sub-name">{{ activeTariffCost }} Stars</p> -->
          </div>
        </div>
        <div v-if="usedPaymentMethod === 'cart'" class="used-payment-method">
          <div class="payment-type-image-block">
            <credit-card-icon class="payment-type-icon" />
          </div>
          <div>
            <p class="menu-item-name">
              {{ $t("tariffPayment.cartPayment") }}
              <span class="coming-soon">Cooming soon</span>
            </p>
            <p class="menu-item-sub-name">
              {{ $t("tariffPayment.cardsVariants") }}
            </p>
          </div>
        </div>
        <div v-else class="used-payment-method">
          <coin-icon class="payment-type-image-block coin" />
          <div>
            <p class="menu-item-name">
              {{ $t("tariffPayment.coinPayment") }}
              <span class="coming-soon">Cooming soon</span>
            </p>
            <p class="menu-item-sub-name">
              {{
                `${$t("tariffPayment.coinBalance")} ${setMainBonus.sum_all ||
                  0} FIN`
              }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="isOpenPaymentOptions" class="payment-variants-container">
        <div
          class="used-payment-method variant"
          @click="setActivePaymentMethod('cart')"
        >
          <div class="payment-type-image-block">
            <credit-card-icon class="payment-type-icon" />
          </div>
          <div>
            <p class="menu-item-name">{{ $t("tariffPayment.cartPayment") }}</p>
            <p class="menu-item-sub-name">
              {{ $t("tariffPayment.cardsVariants") }}
            </p>
          </div>
        </div>
        <div
          class="used-payment-method variant"
          @click="setActivePaymentMethod('coin')"
        >
          <coin-icon class="payment-type-image-block coin" />
          <div>
            <p class="menu-item-name">{{ $t("tariffPayment.coinPayment") }}</p>
            <p class="menu-item-sub-name">
              {{ `Вам доступно ${setMainBonus.sum_all || 0} FIN` }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <p class="payment-title">{{ $t("tariffPayment.tariffPlan") }}</p>
    <div class="payment-period-block">
      <div
        :class="`payment-for-period ${activePeriod === 1 ? 'active' : ''}`"
        @click="setActivePaymentPeriod(1)"
      >
        <div>
          <p class="menu-item-name">
            {{ $t("tariffPayment.payForYear") }}
            <!-- <span class="price-sale">-57%</span> -->
          </p>
          <!-- <p v-if="usedPaymentMethod === 'cart'" class="menu-item-sub-tarif">
            $97 /<span class="old-price">$168</span>
          </p> -->
          <p class="menu-item-sub-tarif">
            {{ proTariff.cost.year }} <star-icon class="star-icon" />
          </p>
        </div>
        <div class="mounth-price-block">
          <!-- <p v-if="usedPaymentMethod === 'cart'" class="menu-item-sub-tarif">
            $8.00/{{ $t("tariffPayment.mounth") }}
          </p> -->
          <p class="menu-item-sub-tarif">
            {{ (proTariff.cost.year / 12).toFixed(1) }}
            <star-icon class="star-icon" />/{{ $t("tariffPayment.mounth") }}
          </p>
        </div>
      </div>
      <div
        :class="`payment-for-period ${activePeriod === 2 ? 'active' : ''}`"
        @click="setActivePaymentPeriod(2)"
      >
        <div>
          <p class="menu-item-name">{{ $t("tariffPayment.payForMounth") }}</p>
          <p class="menu-item-sub-tarif">
            {{ proTariff.cost.month }} <star-icon class="star-icon" />
          </p>
        </div>
        <div class="mounth-price-block">
          <p class="menu-item-sub-tarif">
            {{ proTariff.cost.month }} <star-icon class="star-icon" />/{{
              $t("tariffPayment.mounth")
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="change-status-payments-block">
      <button
        v-for="tariff of paymentsTariffs"
        :key="tariff.id"
        :class="[`status-button ${isActiveTariff === tariff.slug && 'active'}`]"
        @click="setChangeTariff(tariff.slug)"
      >
        <!-- {{ $t("tariffPayment.tariff") }} -->
        {{ tariff.title }}
      </button>
      <!-- <button
        :class="[`status-button ${isActiveTariff === 'pro' && 'active'}`]"
        @click="setChangeTariff('pro')"
      >
        {{ $t("tariffPayment.tariff") }} Pro
      </button>
      <button
        :class="[`status-button ${isActiveTariff === 'start' && 'active'}`]"
        @click="setChangeTariff('start')"
      >
        {{ $t("tariffPayment.tariff") }} Start
      </button> -->
    </div>
    <div class="tariff-permissions-block">
      <div
        class="menu-pages-item"
        v-for="permission of isActiveTariff === 'trial'
          ? startTariffPermissions
          : proTariffPermissions"
        :key="permission.id"
      >
        <div class="menu-item-name-block">
          <img
            :src="onMountImg(permission.img)"
            alt=""
            class="menu-item-image"
          />
          <!-- <div class="menu-item-image">
                        <key-icon class="menu-item-svg" />
                    </div> -->
          <div class="menu-item-tariff-info-block">
            <p class="menu-item-name">{{ permission.title }}</p>
            <p class="menu-item-sub-name">{{ permission.subTitle }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <p class="payment-title">{{ $t("tariffPayment.tariffInfoTitle") }}</p>
    <div class="main-info-block">
      <p class="main-info-text">{{ $t("tariffPayment.tariffInfo") }}</p>
    </div> -->
    <!-- <button class="main-tariff-button" @click="onByTariff">
            {{ `${$t('tariffPayment.payFor')} ${setFindCurrentPrice()}` }}</button> -->

    <button
      v-if="isActiveTariff === 'pro'"
      class="main-tariff-button"
      @click="onByTariff"
    >
      {{ $t("homePage.payForTariff") }}
    </button>
  </div>
</template>

<script>
import {
  //   ChevronRightIcon,
  CreditCardIcon,
  StarIcon,
  // KeyIcon
} from "vue-feather-icons";
import CoinIcon from "../icons/CoinIcon.vue";
import aiAnalytic from "../../../assets/img/tarif_pro/aiAnalytic.png";
import countPro from "../../../assets/img/tarif_pro/countPro.png";
import notificationPro from "../../../assets/img/tarif_pro/notificationPro.png";
import voicePro from "../../../assets/img/tarif_pro/voicePro.png";
import analytic from "../../../assets/img/tarif_start/analytic.png";
import free from "../../../assets/img/tarif_start/free.png";
import limit from "../../../assets/img/tarif_start/limit.png";
import management from "../../../assets/img/tarif_start/managment.png";
import voice from "../../../assets/img/tarif_start/voice.png";
import { mapMutations } from "vuex";
import { onVibrate, setMakeDate } from "../../../helpers/utils";

export default {
  name: "Pay-info-container",
  components: {
    // ChevronRightIcon,
    CreditCardIcon,
    CoinIcon,
    StarIcon,
    // KeyIcon
  },
  props: {},
  data() {
    return {
      isOpenPaymentOptions: false,
      usedPaymentMethod: "stars",
      activePeriod: 1,
      isActiveTariff: "pro",
      proTariffPermissions: [],
      startTariffPermissions: [],
      activeTariffCost: 0,
      Telegram: window.Telegram.WebApp,
      proTariff: {
        cost: {
          month: 0,
          year: 0,
        },
      },
    };
  },
  async mounted() {
    onVibrate("click");
    let data = {
      customer_id: this.currentCustomer.customer_id,
      from: "",
      to: setMakeDate({ id: 0 }).to,
    };
    this.$store.dispatch("getPaymentsTariffs").then((val) => {
      this.proTariff = val.find((el) => el.id === 2);
      console.log(this.proTariff, "123");
    });
    this.$store.dispatch("getInvitedFriends", data);
    this.proTariffPermissions = [
      {
        id: 1,
        title: this.$t("tariffPayment.permissionTitle1"),
        subTitle: this.$t("tariffPayment.permissionDescr1"),
        img: "1",
      },
      {
        id: 2,
        title: this.$t("tariffPayment.permissionTitle2"),
        subTitle: this.$t("tariffPayment.permissionDescr2"),
        img: "2",
      },
      {
        id: 3,
        title: this.$t("tariffPayment.permissionTitle3"),
        subTitle: this.$t("tariffPayment.permissionDescr3"),
        img: "3",
      },
      {
        id: 4,
        title: this.$t("tariffPayment.permissionTitle4"),
        subTitle: this.$t("tariffPayment.permissionDescr4"),
        img: "4",
      },
    ];
    this.startTariffPermissions = [
      {
        id: 1,
        title: this.$t("tariffPayment.permissionTitle5"),
        subTitle: "",
        img: "5",
      },
      {
        id: 2,
        title: this.$t("tariffPayment.permissionTitle6"),
        subTitle: this.$t("tariffPayment.permissionDescr5"),
        img: "6",
      },
      {
        id: 3,
        title: this.$t("tariffPayment.permissionTitle2"),
        subTitle: this.$t("tariffPayment.permissionDescr6"),
        img: "7",
      },
      {
        id: 4,
        title: this.$t("tariffPayment.permissionTitle7"),
        subTitle: this.$t("tariffPayment.permissionDescr7"),
        img: "8",
      },
      {
        id: 5,
        title: this.$t("tariffPayment.permissionTitle8"),
        subTitle: this.$t("tariffPayment.permissionDescr8"),
        img: "9",
      },
    ];
  },

  methods: {
    ...mapMutations([""]),
    onOpenPaymentOptions() {
      this.isOpenPaymentOptions = !this.isOpenPaymentOptions;
    },
    setActivePaymentMethod(value) {
      this.usedPaymentMethod = value;
    },
    setActivePaymentPeriod(period) {
      onVibrate("click");
      this.activePeriod = period;
    },
    setChangeTariff(tariff) {
      onVibrate("click");
      this.isActiveTariff = tariff;
    },
    async onByTariff() {
      onVibrate("click");
      try {
        let data = {
          tariff: this.proTariff.id,
          type: this.activePeriod === 1 ? "year" : "month",
        };
        await this.$store.dispatch("setPurchaseTariff", data);
      } catch (error) {
        console.log(error.message);
      }
      this.Telegram.close();
      console.log("buy");
    },
    setFindCurrentPrice() {
      if (this.usedPaymentMethod === "cart" && this.activePeriod === 1) {
        return `$97 ${this.$t("tariffPayment.forYear")}`;
      } else if (this.usedPaymentMethod === "cart" && this.activePeriod === 2) {
        return `$14 ${this.$t("tariffPayment.forMounth")}`;
      } else if (this.usedPaymentMethod === "coin" && this.activePeriod === 1) {
        return `13 680 FIN ${this.$t("tariffPayment.forYear")}`;
      } else if (this.usedPaymentMethod === "coin" && this.activePeriod === 2) {
        return `2 000 FIN ${this.$t("tariffPayment.forMounth")}`;
      }
    },
    onMountImg(val) {
      switch (val) {
        case "1":
          return voicePro;
        case "2":
          return countPro;
        case "3":
          return aiAnalytic;
        case "4":
          return notificationPro;
        case "5":
          return free;
        case "6":
          return voice;
        case "7":
          return limit;
        case "8":
          return management;
        case "9":
          return analytic;
        default:
          break;
      }
    },
  },
  computed: {
    setMainBonus() {
      return this.$store.getters.setMainBonus;
    },
    currentCustomer() {
      return this.$store.getters.currentCustomer;
    },
    paymentsTariffs() {
      return this.$store.getters.paymentsTariffs;
    },
  },
  watch: {},
};
</script>

<style scoped>
.payment-options-block {
  position: relative;
  border-radius: 22px;
  width: 95%;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
  transition: all 0.5s ease;
  height: 60px;
  cursor: pointer;
  margin-bottom: 20px;
}

.payment-options-block.open {
  height: 180px;
}

.tariff-permissions-block {
  position: relative;
  border-radius: 22px;
  width: 95%;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
  transition: all 0.5s ease;
  margin-bottom: 20px;
  padding: 5px 15px;
}

.menu-item-tariff-info-block {
  display: flex;
  flex-direction: column;
  max-width: 80%;
}

.star-icon {
  width: 15px;
  height: 15px;
  vertical-align: -2px;
  color: #ffa500;
  fill: #ffa500;
  margin-top: 2px;
}

.payment-period-block {
  position: relative;
  border-radius: 22px;
  width: 95%;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
  transition: all 0.5s ease;
  cursor: pointer;
  margin-bottom: 20px;
}

.main-info-block {
  border-radius: 22px;
  width: 95%;
  margin: 0 auto;
  background: #fff;
  transition: all 0.5s ease;
  margin-bottom: 20px;
  padding: 15px;
}

.main-info-text {
  font-family: "Source Sans 3", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #000;
  letter-spacing: -0.6px;
  line-height: 15px;
}

.payment-title {
  font-size: 13px;
  opacity: 0.8;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
  font-weight: 600;
  padding: 0 10px;
  line-height: 20px;
  letter-spacing: 0px;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.dropdown-chevron-icon {
  position: absolute;
  right: 10px;
  top: 20px;
  width: 20px;
  height: 20px;
  margin-left: auto;
  transition: all 0.25s ease;
}

.use-payment-container {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.used-payment-method {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 15px;
  transition: all 0.25s ease;
}

.used-payment-method.variant:hover {
  background-image: var(--main-bg-color);
}

.used-payment-method.variant:hover .menu-item-name {
  color: #fff;
}

.used-payment-method.variant:hover .menu-item-sub-name {
  color: #fff;
}

.payment-for-period {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  height: 60px;
  transition: all 0.25s ease;
}

.payment-for-period.active {
  background-image: var(--main-bg-color);
}

.payment-for-period.active .menu-item-name,
.payment-for-period.active .menu-item-sub-tarif {
  color: #fff;
}

.payment-type-image-block {
  display: flex;
  position: relative;
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 12px;
  background-image: var(--main-bg-color);
}

.payment-type-image-block.coin {
  background-image: none;
}

.payment-type-icon {
  color: #fff;
  width: 18px;
  height: 18px;
  margin: auto;
}

.menu-item-name {
  font-family: "Source Sans 3", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  letter-spacing: -0.6px;
  line-height: 15px;
  cursor: pointer;
  height: 15px;
  margin: auto 0;
  text-align: left;
}

.menu-item-sub-name {
  font-family: "Source Sans 3", sans-serif;
  color: #000;
  letter-spacing: -0.6px;
  line-height: 15px;
  font-size: 11px;
  font-weight: 400;
  opacity: 0.4;
  text-align: left;
}

.menu-item-sub-tarif {
  font-family: "Source Sans 3", sans-serif;
  color: #000;
  letter-spacing: -0.6px;
  line-height: 15px;
  font-size: 15px;
  font-weight: 400;
  opacity: 0.7;
  text-align: left;
}

.payment-variants-container {
  display: flex;
  flex-direction: column;
}

.mounth-price-block {
  display: flex;
  align-items: center;
}

.price-sale {
  padding: 1px 3px;
  background: #ff0000;
  border-radius: 8px;
  margin-left: 4px;
  color: #fff;
}

.old-price {
  margin-left: 5px;
  text-decoration: line-through;
}

.change-status-payments-block {
  background-color: #fff;
  overflow: hidden;
  display: flex;
  padding: 5px;
  border-radius: 20px;
  margin: 10px;
}

.status-button {
  transition: all 200ms ease;
  text-align: center;
  width: 100%;
  margin: auto;
  color: #000;
  line-height: 35px;
  font-size: 13px;
  background-size: cover;
  position: relative;
  z-index: 10;
  overflow: visible;
  background-color: transparent;
  transition: all 0.5s ease;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
  text-transform: capitalize;
}

.status-button.active {
  background-image: var(--main-bg-color);
  color: #fff !important;
}

.menu-pages-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  border: none;
  background: transparent;
}

.menu-pages-item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.menu-item-name-block {
  display: flex;
  gap: 20px;
}

.menu-item-container {
  display: flex;
  align-items: center;
}

.menu-item-image {
  display: flex;
  position: relative;
  text-align: center;
  margin: auto 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 12px;
  background-image: var(--main-bg-color);
}

.menu-item-image:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.85) translateY(5px) translateZ(10px);
  filter: blur(8px);
}

.menu-item-svg {
  color: #fff;
  width: 18px;
  height: 18px;
  margin: auto;
}

.main-tariff-button {
  display: block;
  font-family: "Source Sans 3", sans-serif;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 12px;
  font-size: 13px;
  padding: 14px 20px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
  transition: all 120ms ease;
  background-size: cover;
  position: relative;
  z-index: 10;
  background-image: var(--main-bg-color);
  color: #fff;
  width: 95%;
  border: none;
  margin: 0 auto;
  margin-bottom: 50px;
  cursor: pointer;
}

.main-tariff-button::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.8) translateY(5px) translateZ(0px);
  filter: blur(12px);
}

.coming-soon {
  background: #8cc152;
  padding: 1px 5px;
  border-radius: 10px;
  color: #fff;
  font-size: 10px;
  margin-left: 5px;
}
</style>
